var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNature = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.3 226.1C66.3 226.1 64.2 225.3 62.6 223.8C59.5 220.7 59.5 215.6 62.6 212.5L162.4 112.7C165.5 109.6 170.6 109.6 173.7 112.7C176.8 115.8 176.8 120.9 173.7 124L73.9 223.8C72.4 225.3 70.3 226.1 68.3 226.1Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.1 219.2C116.3 219.2 99.9001 214.4 84.1001 205C83.0001 204.3 82.0001 203.4 81.4001 202.3C63.7001 172.8 62.4001 141.2 78.0001 115.6C99.9001 79.4 151.3 60 215.2 63.8C219.2 64 222.5 67.3 222.7 71.3C226.5 135.3 207.1 186.6 170.9 208.5C159 215.7 145.8 219.2 132.1 219.2ZM94.1001 192.3C118.1 206.1 142.4 207 162.6 194.8C192.4 176.8 208.8 133.9 207.1 79.4C152.6 77.7 109.7 94.1 91.7001 123.9C79.4001 144 80.3001 168.3 94.1001 192.3Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNature, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/nature.022f0af9.svg";
export { ForwardRef as ReactComponent };